//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import querystring from 'query-string'

export default {
  props: {
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      pages: []
    }
  },

  watch: {
    pagination() {
      this.init()
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      const pagination = this.pagination
      const { path, query } = this.$route
      const queryParams = '?' + querystring.stringify(query)

      this.pages = []

      if (pagination.total <= pagination.perPage) return false

      for (let i = 1; i <= pagination.lastPage; i++) {
        const active = pagination.page === i ? 'active' : ''

        if (i === 1) {
          this.pages.push({
            content: `<div class="link-container"><span class="material-icons-outlined"> chevron_left </span> <p>${this.$t(
              'prev'
            )}</p></div>`,
            href:
              path +
              this.setQueryParam(
                this.$t('page'),
                pagination.page === 1 ? pagination.page : pagination.page - 1,
                queryParams
              ),
            classes: `page-first ${
              pagination.page === 1 ? 'page-inactive' : ''
            }`,
            ariaLabel: 'Voltar uma página'
          })
        }

        if (i <= pagination.page && i >= pagination.page - 3) {
          this.pages.push({
            content: i,
            href: path + this.setQueryParam(this.$t('page'), i, queryParams),
            classes: `page ${active ? 'page-active' : ''}`
          })
        } else if (i >= pagination.page && i <= pagination.page + 3) {
          this.pages.push({
            content: i,
            href: path + this.setQueryParam(this.$t('page'), i, queryParams),
            classes: `page ${active ? 'page-active' : ''}`
          })
        }

        if (i === pagination.lastPage) {
          this.pages.push({
            content: ` <div class="link-container"><p>${this.$t(
              'next'
            )}</p> <span class="material-icons-outlined"> chevron_right </span></div>`,
            href:
              path +
              this.setQueryParam(
                this.$t('page'),
                pagination.page === pagination.lastPage
                  ? pagination.lastPage
                  : pagination.page + 1,
                queryParams
              ),
            classes: `page-end ${
              pagination.page === pagination.lastPage ? 'page-inactive' : ''
            }`,
            ariaLabel: 'Ir para a última página'
          })
        }
      }
    },

    setQueryParam(param, newval, search) {
      const regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?')
      const query = search.replace(regex, '$1').replace(/&$/, '')
      return (
        (query.length > 2 ? query + '&' : '?') +
        (newval ? param + '=' + newval : '')
      )
    }
  }
}
